export default "__VITE_ASSET__bcfe3d60__"